<template>
	<div>
			<a-form-model  :model="theObj" :labelCol="{span: 4}" :wrapperCol="{span: 20}">
				<a-row :gutter="24">
					<a-col :span="12">
						<a-form-model-item label="片区" prop="departmentName">
							<a-input  v-model="theObj.departmentName" :disabled="true"/>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item label="备注" >
							<a-input  v-model="theObj.remark" :disabled="true"/>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row :gutter="24">
					<a-col :span="12">
						<a-form-model-item label="小区">
							<a-select placeholder="请选择小区"  show-search v-model="selectedNeighbor" 
							 option-filter-prop="children" :filter-option="filterOption" @change="onChange">
								<a-select-option v-for="(item,index) in list"  :value="item.pId" :key="item.pId">
									{{item.neighborName}}
								</a-select-option>
							</a-select>
						</a-form-model-item>
					</a-col>
					<a-col :span="12">
						<a-form-model-item>
							<a-button type="primary" icon="plus" :disabled="selectedNeighbor==undefined" @click="addNeighborRel">添加小区</a-button>
						</a-form-model-item>
					</a-col>
				</a-row>
			</a-form-model>
			<a-table size="small" :columns="columns" :data-source="selectedList" bordered   rowKey="pId" :pagination="false"
						  style="margin-top: 1.25rem;" :scroll="{y:600}">
				<span slot="theAction" slot-scope="text, record">
						<a-button size="small" icon="delete" type="link" @click="deleteNeighborRel(record)">删除</a-button>
				</span>
			</a-table>
	</div>
</template>

<script>
	const columns = [
		{
			title: '小区',
			dataIndex: 'neighborName',
			width:200,
			ellipsis :true,
		},
		{
			title: '地址',
			dataIndex: 'neighborAddr',
			width:200,
			ellipsis :true,
		},
		{
		    title: '操作',
		    key: 'pId',
		    scopedSlots: { customRender: 'theAction' },
			width:60,
			align:'center',
		  },
	];
	export default{
		props:[
			'theObj',
		],
		data(){
			return {
				columns,
				selectedNeighbor:undefined,
				list:[],
				selectedList:[],
			}
		},
		methods:{
			filterOption(input, option) {
				return (
					option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
				);
			},
			onChange:function(value){
				this.selectedNeighbor = value;
			},
			resetSelectedList:function(result){
				this.selectedList = [];
				for(var i =0;i<result.length;i++){
					let detailItem = result[i];
					let newItem = this.getTheNeighborWithId(detailItem.NID);
					if(newItem!=null){
						this.selectedList.push(newItem);
					}
				}
			},
			getTheNeighborWithId:function(neighborId){
				for(var j =0;j<this.list.length;j++){
					let listItem =  this.list[j];
					if(neighborId== listItem.pId){
						return listItem;
					}
					
				}
				return null;
			},
			deleteNeighborRel:function(record){
				let url = this.Api.getLastUrl(this.Api.NEIGHBOR_DEPART_DEL_REL_URL);
				let param = {departId:this.theObj.pId,neighborId:record.pId};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					let code = data.data.code;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.queryNeighborIds();
					}else{
						this.$message.error(msg);
					}
					}).catch((error)=>{
						console.log(error);
				});
			},
			addNeighborRel:function(){
				let flag = false;
				console.log(this.selectedList);
				for(var i=0;i<this.selectedList.length;i++){
					let obj = this.selectedList[i];
					if(obj == null){
						break;
					}
					if(obj.pId == this.selectedNeighbor){
						flag = true;
						break;
					}
				}
				if(flag){
					this.$message.error('该小区已存在');
				}else{
					let url = this.Api.getLastUrl(this.Api.NEIGHBOR_DEPART_ADD_REL_URL);
					let param = {departId:this.theObj.pId,neighborId:this.selectedNeighbor};
					this.Api.fetchPostWithForm(url,param).then((data)=>{
						let code = data.data.code;
						let msg = data.data.message;
						if(code == this.Api.HTTP_OK_CODE){
							this.queryNeighborIds();
						}else{
							this.$message.error(msg);
						}
						}).catch((error)=>{
							console.log(error);
					});
				}
			},
			queryDataList:function(){
				let url = this.Api.getLastUrl(this.Api.NEIGHBOR_DEPART_NO_ORDER_URL);
				this.Api.fetchPostWithForm(url).then((data)=>{
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.list = result;
						this.queryNeighborIds();
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.loading = false;
					console.log(error);
				});
			},
			queryNeighborIds:function(){
				let url = this.Api.getLastUrl(this.Api.NEIGHBOR_DEPART_NEIGHBORIDS_URL);
				let param={departId:this.theObj.pId};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.resetSelectedList(result);
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.loading = false;
					console.log(error);
				});
			},
		},
		created() {
			this.queryDataList();
		},
	}
</script>

<style>
</style>
